import clsx from 'clsx';
import PropTypes from 'prop-types';
import React from 'react';

import GradientBorder from 'components/shared/gradient-border';
import Link from 'components/shared/link';

const CaseStudyCard = ({
  logo,
  logoWidth,
  logoHeight,
  logoTheme,
  title,
  description,
  linkText,
  linkUrl,
  theme,
}) => (
  <section
    className={clsx('case-study-card safe-paddings py-5', theme === 'gray' && 'bg-new-gray-2')}
  >
    <div className="container">
      <h2 className="sr-only">{title}&apos;s case study</h2>
      <div className="mx-auto flex max-w-[832px] items-center xl:max-w-[632px] lg:max-w-[478px]">
        <div className="flex items-center gap-10 xl:gap-9 lg:gap-6 sm:flex-col sm:gap-7">
          <div
            className={clsx(
              'relative flex size-[210px] shrink-0 items-center justify-center rounded-[32px] shadow-[0_3px_16px_0_rgba(73,46,107,0.14)] xl:size-[170px] xl:rounded-[28px] lg:size-[140px] lg:rounded-3xl sm:w-full sm:rounded-2xl',
              logoTheme === 'white' && 'bg-white',
              logoTheme === 'gray' && 'bg-case-study-gradient'
            )}
          >
            <img
              className="shrink-0 xl:scale-[0.8] lg:scale-[0.65]"
              src={logo.src}
              alt={`${title}'s logo`}
              width={logoWidth}
              height={logoHeight}
              loading="lazy"
            />
            <GradientBorder className="border-image-[linear-gradient(135deg,#EBEDF5,#FFFFFF)]" />
          </div>
          <div className="flex-1">
            <p
              className="font-sans2 text-[30px] leading-snug tracking-[-0.03em] text-new-black xl:text-[24px] lg:text-[18px] [&_strong]:font-medium [&_strong]:text-new-primary-1"
              dangerouslySetInnerHTML={{ __html: description.replace(/\s/g, ' ') }}
            />
            <Link
              className="mt-6 xl:text-[16px] lg:mt-[18px] lg:text-[14px] md:mt-4"
              to={linkUrl}
              size="md"
              theme="secondary-2"
              withArrow
            >
              {linkText}
            </Link>
          </div>
        </div>
      </div>
    </div>
  </section>
);

CaseStudyCard.propTypes = {
  logo: PropTypes.shape({
    src: PropTypes.string.isRequired,
  }).isRequired,
  logoWidth: PropTypes.number.isRequired,
  logoHeight: PropTypes.number.isRequired,
  logoTheme: PropTypes.oneOf(['white', 'gray']).isRequired,
  title: PropTypes.string.isRequired,
  description: PropTypes.string.isRequired,
  linkText: PropTypes.string.isRequired,
  linkUrl: PropTypes.string.isRequired,
  theme: PropTypes.oneOf(['white', 'gray']).isRequired,
};

export default CaseStudyCard;
